module.exports = __webpack_public_path__ + "img/js-banner-4.e0a33807.png";